import type { ComparisonGroup } from '@entities/mto';
import { Badge } from '@shared/ui/Badge';
import { Caption, Muted, Table, TableScroll } from '../styles';
import { GroupRowView } from './GroupRowView';

export function GroupsSection({
  groups,
  runId,
  canWrite,
  onError,
}: {
  groups: ComparisonGroup[];
  runId: string;
  canWrite: boolean;
  onError: (msg: string) => void;
}) {
  return (
    <>
      <Caption>
        Похожие позиции без справочника <Badge $tone="neutral">{groups.length}</Badge>
      </Caption>
      <Muted>
        В справочнике этих позиций нет, но у разных КП одна марка изделия — цены уже сравнены.
        Откройте строку и нажмите «Добавить в справочник», чтобы выбрать поставщика.
      </Muted>
      <TableScroll>
        <Table>
          <thead>
            <tr>
              <th scope="col">Позиция</th>
              <th scope="col" className="num">
                Предложений
              </th>
              <th scope="col" className="num">
                Минимум
              </th>
              <th scope="col" className="num">
                Разброс
              </th>
              <th scope="col" className="num">
                Тренд
              </th>
              <th scope="col">Справочник</th>
            </tr>
          </thead>
          <tbody>
            {groups.map((g) => (
              <GroupRowView
                key={g.key}
                group={g}
                runId={runId}
                canWrite={canWrite}
                onError={onError}
              />
            ))}
          </tbody>
        </Table>
      </TableScroll>
    </>
  );
}
